/*
  Product cards: image slider and quick add to cart.

  Cards are set up when the page loads and again whenever new cards are added to the page
  (filtering, sorting, paging, as-you-type search, recommendations).
*/
(function () {
  'use strict';

  // Card photo sliders are set up only when the card comes near the screen, so a page of cards
  // doesn't do all that work while it is loading.
  var sliderWatcher = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      sliderWatcher.unobserve(entry.target);
      makeSlider(entry.target);
    });
  }, { rootMargin: '300px 0px' }) : null;

  // remembered in memory, not on the element, because the card pager copies cards (and their attributes)
  var watched = typeof WeakSet === 'function' ? new WeakSet() : null;

  function initSliders(root) {
    if (typeof Swiper === 'undefined') return;
    root.querySelectorAll('.product-grid-swiper').forEach(function (el) {
      if (el.swiper || (watched && watched.has(el))) return;
      if (sliderWatcher && watched) {
        watched.add(el);
        sliderWatcher.observe(el);
      } else {
        makeSlider(el);
      }
    });
  }

  function makeSlider(el) {
    if (el.swiper) return;
    (function () {
      new Swiper(el, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        simulateTouch: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        },
        watchOverflow: true,
      });
    })();
  }

  function initQuickAdd(root) {
    root.querySelectorAll('[data-quick-add]').forEach(function (button) {
      if (button.dataset.quickAddBound === 'true') return;
      button.dataset.quickAddBound = 'true';

      var inProgress = false;

      button.addEventListener('click', function (event) {
        event.preventDefault();

        if (inProgress) return;
        inProgress = true;

        var variantId = button.getAttribute('data-variant-id');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            button.classList.add('is-added');
            setTimeout(function () { button.classList.remove('is-added'); }, 1500);
            Spruce.store('drawer').cartOpener = button;
            if (!Spruce.store('drawer').cartDrawerOpen) {
              document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem'));
              Spruce.store('drawer').cartDrawerOpen = true;
            }
          })
          .catch(function (err) {
            console.error('Add to cart error:', err);
          })
          .finally(function () {
            setTimeout(function () {
              inProgress = false;
            }, 500);
          });
      });
    });
  }

  function init(root) {
    root = root || document;
    initSliders(root);
    initQuickAdd(root);
  }

  // Option picker on cards: "+" opens the options, choosing one adds it (the option buttons are quick-add buttons)
  function closePickers(except) {
    document.querySelectorAll('[data-quick-pick-panel]:not([hidden])').forEach(function (panel) {
      if (panel === except) return;
      panel.hidden = true;
      var trigger = panel.parentElement.querySelector('[data-quick-pick]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-pick]');
    if (trigger) {
      event.preventDefault();
      var panel = trigger.parentElement.querySelector('[data-quick-pick-panel]');
      if (!panel) return;
      closePickers(panel);
      panel.hidden = !panel.hidden;
      trigger.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      return;
    }
    var option = event.target.closest('.fount-quick-pick__option');
    if (option) { setTimeout(function () { closePickers(null); }, 300); return; }
    if (!event.target.closest('[data-quick-pick-panel]')) closePickers(null);
  });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closePickers(null); });

  window.FountProductGrid = { init: init };

  function start() {
    init(document);

    // Cards added later
    var pending = false;
    new MutationObserver(function (mutations) {
      var added = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (!added || pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        init(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
